<section class="main-content wrapper content-padding" style="margin-top: 50px;">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a
          class="tab-link"
          routerLink="/collections"
          routerLinkActive="active-tab"
        >
          SHOP PRODUCTS COLLECTION
        </a>
      </label>
    </div>

    <div class="heading">
        <div class="button-wrapper">
            <button class="btn hvr-grow has-margin-right" routerLink="/collections/nuovo"> 
                ADD NEW COLLECTION<i class="ml-10 fas fa-plus"></i>
            </button>
        </div>
    </div>

    <section class="main-content wrapper content-padding scroll-delivery">
        <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
        <div class="table-responsive-invoice has-margin-top">
            <div class="custom-data-output has-margin-top" role="table" id="elencoConsegneAdmin">
                <form class="table-row-container row first-row filter" [formGroup]="collectionFilterForm" (ngSubmit)="filter()" *ngIf="collectionFilterForm">

                    <div class="item data-col-5">
                        <h4 class="title" (click)="navigateOrder('ShopCollections.id')">
                            <i class="sort-icon fas" [ngClass]="orderIcon('ShopCollections.id')"></i>
                            ID
                        </h4>
                        <span class="data">
                            <input type="number" formControlName="ShopCollections.id" min="1000" max="10000">
                        </span>
                    </div>                    

                    <div class="item data-col-5">
                        <h4 class="title" (click)="navigateOrder('ShopCollections.collectionName')">
                            <i class="sort-icon fas" [ngClass]="orderIcon('ShopCollections.collectionName')"></i>
                            COLLECTION NAME
                        </h4>
                        <span class="data">
                            <input type="text" formControlName="ShopCollections.collectionName" >
                        </span>
                    </div>                    

                    <div class="item data-col-5">
                        <h4 class="title" (click)="navigateOrder('ShopCollections.handle')">
                            <i class="sort-icon fas" [ngClass]="orderIcon('ShopCollections.handle')"></i>
                            COLLECTION HANDLE
                        </h4>
                        <span class="data">
                            <input type="text" formControlName="ShopCollections.handle" >
                        </span>
                    </div>                    

                    <div class="item data-col-5">
                        <h4 class="title" (click)="navigateOrder('ShopCollections.bodyHtml')">
                            <i class="sort-icon fas" [ngClass]="orderIcon('ShopCollections.bodyHtml')"></i>
                            COLLECTION DESCRIPTION
                        </h4>
                        <span class="data">
                            <input type="text" formControlName="ShopCollections.bodyHtml" >
                        </span>
                    </div>                    

                    <div class="item data-col-5">
                        <h4 class="title" (click)="navigateOrder('Provinces.province')">
                            <i class="sort-icon fas" [ngClass]="orderIcon('Provinces.province')"></i>
                            PROVINCE
                        </h4>
                        <span class="data">
                            <input type="text" formControlName="Provinces.province" >
                        </span>
                    </div>                    

                    <div class="item data-col-5">
                        <h4 class="title" (click)="navigateOrder('Provinces.provinceCode')">
                            <i class="sort-icon fas" [ngClass]="orderIcon('Provinces.provinceCode')"></i>
                            PROVINCE CODE
                        </h4>
                        <span class="data">
                            <input type="text" formControlName="Provinces.provinceCode" >
                        </span>
                    </div>                    

                    <div class="item data-col-5">
                        <h4 class="title" (click)="navigateOrder('ProductCategory.categoryName')">
                            <i class="sort-icon fas" [ngClass]="orderIcon('ProductCategory.categoryName')"></i>
                            PRODUCT CATEGORY
                        </h4>
                        <span class="data">
                            <input type="text" formControlName="ProductCategory.categoryName" >
                        </span>
                    </div>                    
        
                    <div class="item nowrap">
                        <h4 class="title hide-on-mobile">AZIONI</h4>
                        <span class="data-row-left btn-container">
                        <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                            RICERCA <i class="fas fa-search"></i></button>
                            <br/>
                        <button class="btn vertical align-items-center" (click)="resetFliter();">
                            RESET <i class="fas fa-times-circle"></i></button>
                        </span>
                    </div>
                </form>

                <div class="table-row-container row" *ngFor="let collection of collections">

                    <div class="data-id item data-col-5">
                        <span class="data-row-left">
                            <h4 class="title table-title">ID :</h4>
                            <a [routerLink]="['/collections/edit', collection.id]">
                                #{{ collection.id }}
                            </a>
                        </span>
                    </div>                                   

                    <div class="item data-col-5">
                        <span class="data-row-left">
                            <h4 class="title table-title">COLLECTION NAME :</h4>
                            <a [routerLink]="['/collections/edit', collection.id]">
                                {{ collection.collectionName }}
                            </a>
                        </span>
                    </div>                                   

                    <div class="item data-col-5">
                        <span class="data-row-left">
                            <h4 class="title table-title">COLLECTION HANDLE :</h4>
                            <a [routerLink]="['/collections/edit', collection.id]">
                                {{ collection.handle }}
                            </a>
                        </span>
                    </div>                                   

                    <div class="item data-col-5">
                        <span class="data-row-left">
                            <h4 class="title table-title">COLLECTION DESCRIPTION :</h4>
                            <a [routerLink]="['/collections/edit', collection.id]">
                                {{ collection.bodyHtml }}
                            </a>
                        </span>
                    </div>                                   

                    <div class="item data-col-5">
                        <span class="data-row-left">
                            <h4 class="title table-title">PROVINCE :</h4>
                            <a [routerLink]="['/collections/edit', collection.id]">
                                {{ collection?.province?.province || "---" }}
                            </a>
                        </span>
                    </div>                                   

                    <div class="item data-col-5">
                        <span class="data-row-left">
                            <h4 class="title table-title">PROVINCE CODE :</h4>
                            <a [routerLink]="['/collections/edit', collection.id]">
                                {{ collection?.province?.provinceCode || "---" }}
                            </a>
                        </span>
                    </div>                          
                    
                    <div class="item data-col-10 center partner-sold-category-column">
                        <h4 class="title">Partner's Catalog</h4>
                        <div *ngIf="collection.shopCollectionProductCategories?.length > 0">
                            <a [routerLink]="['/collections/edit', collection.id]">
                                <span *ngFor="let data of collection?.shopCollectionProductCategories; let last = last">{{ data?.productCategory?.categoryName }}
                                    <ng-container *ngIf="!last">, </ng-container>
                                </span>
                            </a>
                        </div>
                        <div *ngIf="collection.shopCollectionProductCategories?.length === 0"> 
                            <a [routerLink]="['/collections/edit', collection.id]">---</a>
                        </div>
                    </div>

                    <div class="item nowrap">
                        <span class="data-row-left btn-container btn-container-actions">
                            <button class="btn vertical align-items-center" [routerLink]="['/collections/edit', collection.id]" *ngIf="groups.includes('admin') || groups.includes('operation')">
                                Modifica
                            </button>
                            <button class="btn btn-red vertical align-items-center" (click)="deleteShopCollection(collection.id)">
                                Elimina<i class="ml-10 far fa-trash-alt"></i>
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </section>
  </div>
</section>